import React, { useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import appConfig from '../config/appConfig';
import styles from './DeepLinkPage.module.css';

export default function DeepLinkProfile() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [attempted, setAttempted] = useState(false);

  const deepLink = useMemo(() => `${appConfig.deepLinkScheme}profile/${encodeURIComponent(id || '')}`, [id]);

  const openApp = (platform) => {
    setAttempted(true);
    // Conceptual: try the scheme; mobile OS will route if installed.
    window.location.href = deepLink;
    // Platform is used to guide fallback copy / future branching.
    void platform;
  };

  return (
    <div className={styles.page}>
      <div className={styles.topBar}>
        <button className={styles.brand} onClick={() => navigate('/')}>
          <img className={styles.brandLogo} src="/timeline-logo.jpeg" alt="Timeline logo" />
          Timeline
        </button>
        <button className={styles.homeBtn} onClick={() => navigate('/')}>Back to home</button>
      </div>

      <main className={styles.main}>
        <motion.div
          initial={{ opacity: 0, y: 16, filter: 'blur(10px)' }}
          animate={{ opacity: 1, y: 0, filter: 'blur(0px)' }}
          transition={{ duration: 0.75, ease: [0.22, 1, 0.36, 1] }}
          className={styles.card}
        >
          <div className={styles.kicker}>Deep link detected</div>
          <h1 className={styles.h1}>This profile will open in the Timeline app.</h1>
          <p className={styles.p}>
            If you have the app installed, tap a button below to continue.
            If not, you’ll see “coming soon” until launch.
          </p>

          <div className={styles.routeRow}>
            <div className={styles.routePill}>
              <span className={styles.routeLabel}>Profile</span>
              <span className={styles.routeValue}>{id || '-'}</span>
            </div>
            <div className={styles.routePillSoft}>
              <span className={styles.routeLabel}>Deep link</span>
              <span className={styles.routeValueMono}>{deepLink}</span>
            </div>
          </div>

          <div className={styles.actions}>
            <button className={styles.primary} onClick={() => openApp('ios')}>Open in iOS App</button>
            <button className={styles.secondary} onClick={() => openApp('android')}>Open in Android App</button>
          </div>

          {attempted ? (
            <div className={styles.hint}>
              If nothing happened, the app probably isn’t installed yet.
            </div>
          ) : null}

          <div className={styles.availability}>
            <div className={styles.avCard}>
              <div className={styles.avTitle}>iOS</div>
              <div className={styles.avMeta}>{appConfig.ios.launched ? 'Available' : 'Coming soon'}</div>
              <div className={`${styles.avBadge} ${appConfig.ios.launched ? styles.avLive : styles.avSoon}`}>
                {appConfig.ios.launched ? 'LIVE' : 'SOON'}
              </div>
            </div>
            <div className={styles.avCard}>
              <div className={styles.avTitle}>Android</div>
              <div className={styles.avMeta}>{appConfig.android.launched ? 'Available' : 'Coming soon'}</div>
              <div className={`${styles.avBadge} ${appConfig.android.launched ? styles.avLive : styles.avSoon}`}>
                {appConfig.android.launched ? 'LIVE' : 'SOON'}
              </div>
            </div>
          </div>
        </motion.div>
      </main>
    </div>
  );
}
